import { useState, useEffect } from "react";
import { observer } from 'mobx-react';
import Header from "../shared/header";
import Footer from "../shared/footer";
import LanguageMenu from "../../my-data/language-menu/language-menu";
import { Grid, Box, Typography, Button, Paper, Skeleton, TextField, Switch, CircularProgress, Snackbar, Alert } from "@mui/material";
import styles from './edit-card.module.scss';
import { ArrowSquareLeft, ArrowSquareRight, Eye, GalleryEdit, Trash } from 'iconsax-react';
import NavButton from "../shared/components/nav-btn";
import EditCardUiStore from "./edit-card-ui-store";
import { useParams } from 'react-router';
import SaveIcon from '../../icons/save-icon.png'
import { singleSectionCategories } from "../../constants/general";
import EditSection from "./edit-section";
import EditImageModal from './edit-image-modal';
import RoundButton from "../shared/components/round-btn";
import DeleteCardModal from "../cards/delete-card-modal";
import { Tabs, Tab } from 'react-tabs-scrollable'
import 'react-tabs-scrollable/dist/rts.css'
import "./mui-tabs.css";

const uiStore = new EditCardUiStore();

const EditCard = observer(({ history, context, location }) => {
    const [language, setLanguage] = useState('English');
    const [showLanguageMenu, setShowLanguageMenu] = useState(false);
    const { card, categories, categoryInformation } = uiStore;
    const [start] = useState(0);
    const { cardId } = useParams();
    const [selectedTab, setSelectedTab] = useState('Card Settings');
    const [isPublic, setPublic] = useState(false);
    const [allowFollowing, setFollow] = useState(false);
    const [allowSyncing, setSync] = useState(false);
    const [loading, setLoading] = useState(false);
    const [infos, setInfos] = useState(null);
    const [sections, setSections] = useState([]);
    const [sectionTypes, setSectionTypes] = useState([]);
    const [labels, setLabels] = useState([]);
    const { defaults } = uiStore;
    const [tabsSize,] = useState(window.innerWidth > 800 ? 6 : 3);
    const [showEditImgModal, setShowEditImgModal] = useState(false);
    const [showDeleteCardModal, setShowDeleteCardModal] = useState(false);
    const [name, setName] = useState(card?.name || '');
    const [showSnackbar, setShowSnackbar] = useState(false);
    // define state with initial value to let the tabs start with that value
    const [activeTab, setActiveTab] = useState(0);

    // define a onClick function to bind the value on tab click
    const onTabClick = (e, index) => {
        setActiveTab(index)
    }

    useEffect(() => {
        async function fetchData() {
            uiStore.initliazeContext(context);
            const card = await uiStore.fetchCard(cardId);
            await uiStore.fetchCategories();
            // const url = new URLSearchParams(location?.search);
            // const category = url.get('category');
            // if (category) {
            //     switchToCategory(category);
            // }
            setName(card?.name);
        }

        fetchData();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cardId, context]);

    useEffect(() => {
        if (card) {
            setPublic(card?.isPublic);
            setFollow(card?.allowFollowing);
            setSync(card?.allowSyncing);
            setName(card?.name);
        }
    }, [card]);

    useEffect(() => {
        if (selectedTab === 'Card Settings') {
            history.push({
                pathname: window.location.pathname,
                search: ''
            })
        } else {
            history.push({
                pathname: window.location.pathname,
                search: '?category=' + selectedTab
            })
        }
    }, [history, selectedTab]);

    useEffect(() => {
        const data = categoryInformation[selectedTab];
        const info = data?.infos.filter(i => i.infoLanguage === language)
        setSections(data?.sections.filter(i => info.find(k => k.section === i._id)));
        setInfos(info);


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [language]);

    const handleSettingsChange = (e, field) => {
        const checked = !!e.target.checked;

        const body = {
            isPublic,
            allowFollowing,
            allowSyncing,
        };

        if (field === 'sync') {
            setSync(checked);
            body.allowSyncing = checked;
        } else if (field === 'follow') {
            setFollow(checked);
            body.allowFollowing = checked;
        } else {
            setPublic(checked);
            body.isPublic = checked;
        }

        uiStore.updateCardSettings(card?._id, body);
    };

    const switchToCategory = async (category) => {
        setLoading(true);
        setSelectedTab(category);
        let data = categoryInformation[category];
        if (!data) {
            data = await uiStore.fetchCategoryInfo(category);
        }
        const info = data.infos.filter(i => i.infoLanguage === language)
        setSectionTypes(data.sectionTypes);
        setSections(data.sections.filter(i => info.find(k => k.section === i._id)));
        setLabels(data.labels);
        setInfos(info);
        setLoading(false);
    }

    const afterDeleteCard = () => {
        history.push('/cards');
    }

    const saveCardName = () => {
        uiStore.updateCardName(name, card?._id);
        setShowSnackbar(true);
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setShowSnackbar(false);
    };

    return (
        <>
            <Header page="cards"></Header>
            <Grid className='content' container>
                <Box className={styles.wrapper}>
                    <Grid container className={styles.pageHeader}>
                        <Grid item xl={6} sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignContent: 'center' }}>
                            <Typography variant="h5" color='#242333'>
                                <b>Edit Card</b> - {card?.name}
                            </Typography>
                        </Grid>
                        <Grid item xl={6} sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', alignContent: 'center' }}>
                            <RoundButton
                                startIcon={
                                    <Eye
                                        size="24"
                                        variant="Bulk"
                                    />
                                }
                                variant="contained"
                                color="lightblue"
                                sx={{ mr: 1 }}
                                href={'/card/' + card?._id}
                            >
                                View card
                            </RoundButton>
                        </Grid>

                    </Grid>
                    <Box>
                        <Tabs
                            activeTab={activeTab}
                            onTabClick={onTabClick}
                            rightBtnIcon={
                                <ArrowSquareRight
                                    size="32"
                                    color={(start + tabsSize) >= categories.length ? "#888888" : "#242333"}
                                    variant="Bulk"
                                />
                            }
                            leftBtnIcon={
                                <ArrowSquareLeft
                                    size="32"
                                    color={start <= 0 ? "#888888" : "#242333"}
                                    variant="Bulk"
                                />
                            }
                            hideNavBtns={false}
                            hideNavBtnsOnMobile={false}
                        >
                            <Tab onClick={() => setSelectedTab('Card Settings')}>Settings</Tab>
                            {categories.map((item) => (
                                <Tab key={item._id} onClick={() => switchToCategory(item.name)}>{item.name}</Tab>
                            ))}
                        </Tabs>
                    </Box>

                    <NavButton children open>
                        <Typography sx={{ justifyContent: 'flex-start', width: '100%', padding: '20px', borderRadius: 0 }} fontWeight='700'>
                            {selectedTab}
                            {selectedTab !== 'Card Settings' && <> - {language}</>}
                        </Typography>
                    </NavButton>
                    <Paper sx={{ borderRadius: '0 0 16px 16px' }} className={styles.mydataInfoContainer}>
                        <Box sx={{ padding: '20px', maxWidth: "500px", m: '0 auto' }}>
                            {selectedTab === 'Card Settings' ?
                                <>
                                    <Box className={styles.cardImg}>
                                        {card ? (
                                            <Button onClick={() => setShowEditImgModal(true)}>
                                                <Box className={styles.uploadImageOverlay}>
                                                    <GalleryEdit className={styles.uploadImageIcon} size="24" variant="Bulk" />
                                                </Box>
                                                <img src={card.image} alt="personal profile pic" />
                                            </Button>
                                        ) : (
                                            <Skeleton
                                                variant="circular"
                                                width={150}
                                                height={150}
                                            />
                                        )}
                                    </Box>
                                    <Box sx={{ mt: 3, mb: 3, display: "flex", justifyContent: 'space-between' }}>
                                        <TextField
                                            size="small"
                                            label='Card Name'
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            sx={{ mr: 2, width: '90%', maxWidth: '300px', mt: 1 }}
                                            disabled={card?.isBasic}
                                        />
                                        {!card?.isBasic &&
                                            <Button
                                                variant="contained"
                                                color='secondary'
                                                endIcon={<img src={SaveIcon}
                                                    alt='Save icon'
                                                    width={24}
                                                />}
                                                size='medium'
                                                onClick={saveCardName}
                                                disabled={!name || name === card?.name}
                                                sx={{ mt: 1 }}
                                            >
                                                Save
                                            </Button>
                                        }
                                        <Snackbar open={showSnackbar} autoHideDuration={6000} onClose={handleClose}>
                                            <Alert onClose={handleClose} severity="success">
                                                Card name have been updated
                                            </Alert>
                                        </Snackbar>
                                    </Box>
                                    <Box>
                                        <Typography fontWeight={600} fontSize={16} sx={{ mb: 2 }}>Card Privacy Settings</Typography>
                                        <Box sx={{ display: 'flex' }}>
                                            <Switch
                                                color="secondary"
                                                onChange={(e) => handleSettingsChange(e, 'public')}
                                                checked={isPublic}
                                                size="small"
                                                sx={{ mb: 4 }}
                                            />
                                            <Box>
                                                <Typography fontSize={14}>Public</Typography>
                                                <Typography fontSize={12} color="#888">Your card will be listed to be found by others</Typography>
                                            </Box>
                                        </Box>
                                        {!card?.isBasic && isPublic &&
                                            <>
                                                <Box sx={{ display: 'flex' }}>
                                                    <Switch
                                                        color="secondary"
                                                        onChange={(e) => handleSettingsChange(e, 'sync')}
                                                        checked={allowSyncing}
                                                        size="small"
                                                        sx={{ mb: 4 }}
                                                    />
                                                    <Box>
                                                        <Typography fontSize={14}>Sync</Typography>
                                                        <Typography fontSize={12} color="#888">People need your permission to be n'Sync with you.</Typography>
                                                    </Box>
                                                </Box>
                                            </>
                                        }

                                    </Box>
                                    {!card?.isBasic &&
                                        <Box className={styles.deleteCardBox}>
                                            Delete Card
                                            <RoundButton
                                                size='small'
                                                variant="contained"
                                                color="redButton"
                                                startIcon={<Trash size={24} variant='Bulk' />}
                                                onClick={() => setShowDeleteCardModal(true)}
                                            >
                                                Delete
                                            </RoundButton>
                                        </Box>
                                    }
                                </>
                                :
                                <>
                                    {loading ?
                                        <>
                                            <CircularProgress />
                                        </>
                                        :
                                        sectionTypes?.map(type =>
                                            <Box key={type}>
                                                {!!sections?.filter(i => i.name === type).length && !singleSectionCategories.includes(selectedTab) &&
                                                    <b>{type}</b>
                                                }

                                                {sections?.filter(i => i.name === type).map(section =>
                                                    <EditSection
                                                        key={section._id}
                                                        section={section}
                                                        infos={infos}
                                                        labels={labels}
                                                        uiStore={uiStore}
                                                        category={selectedTab}
                                                        defaultSection={['Socials', 'Name'].includes(selectedTab) ?
                                                            defaults[type]?.sectionID === section._id
                                                            :
                                                            defaults[selectedTab]?.sectionID === section._id
                                                        }
                                                    />
                                                )}

                                            </Box>

                                        )
                                    }

                                </>
                            }
                        </Box>
                    </Paper>
                </Box>
            </Grid >
            <DeleteCardModal show={showDeleteCardModal} setShow={setShowDeleteCardModal} uiStore={uiStore} card={card} afterDeleteCard={afterDeleteCard} />
            <EditImageModal show={showEditImgModal} setShow={setShowEditImgModal} uiStore={uiStore} selected={card?.image} cardId={cardId} />
            <LanguageMenu language={language} setLanguage={setLanguage} uiStore={uiStore} show={showLanguageMenu} setShow={setShowLanguageMenu} page={'edit-card'} />
            <Footer></Footer>
        </>
    );
});

export default EditCard;